/**
 * Utilitaires pour champs numériques décimaux :
 * - Affichage avec virgule (convention française)
 * - Touche "." du pavé numérique convertie en "," à la saisie
 */

/**
 * Formate un nombre pour l'affichage (séparateur décimal = virgule).
 */
export function formatDecimal(value: number | undefined | null): string {
  if (value === undefined || value === null || Number.isNaN(value)) return "";
  const s = String(value);
  return s.includes(".") ? s.replace(".", ",") : s;
}

/**
 * Parse une chaîne saisie (virgule ou point) en nombre.
 */
export function parseDecimal(value: string): number {
  if (value === "" || value === undefined) return 0;
  const normalized = value.trim().replace(",", ".");
  const n = parseFloat(normalized);
  return Number.isNaN(n) ? 0 : n;
}

/**
 * Gère la touche "." : insertion d'une virgule à la place (pour pavé numérique).
 * À utiliser sur les champs décimaux avec value affichée en virgule.
 */
export function handleDecimalKeyDown(
  e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>,
  currentValue: string,
  onChangeValue: (num: number) => void
): void {
  if (e.key !== ".") return;
  e.preventDefault();
  const input = e.currentTarget;
  const start = input.selectionStart ?? 0;
  const end = input.selectionEnd ?? start;
  const newStr = currentValue.slice(0, start) + "," + currentValue.slice(end);
  onChangeValue(parseDecimal(newStr));
  requestAnimationFrame(() => {
    const pos = start + 1;
    input.setSelectionRange(pos, pos);
  });
}
